export default function exploreSeo() {
  const widgetName = 'exploreSeo';
  const widgetOpts = exploreSeoOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createExploreSeo(data.items[0]);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });

  function createExploreSeo(widgetData) {
    const { Title, Description } = widgetData;
    const $seo = $widget.find('.card-widget-item');

    $seo.replaceWith(`
      <h2 class="explore-title">${Title}</h2>
      ${Description ? `<div class="explore-description">${Description}</div>` : ''}
    `);
  }
}
